import "core-js/modules/es7.object.get-own-property-descriptors.js";
import "core-js/modules/es6.symbol.js";
import "core-js/modules/web.dom.iterable.js";
import "core-js/modules/es6.object.to-string.js";
import "core-js/modules/es6.object.keys.js";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import "core-js/modules/es6.number.constructor.js";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { mapMutations } from 'vuex';
import updatePageNumber from '~/helpers/pagination-helper';

var MdmLoader = function MdmLoader() {
  return import(
  /* webpackChunkName: "mdm-loader" */
  '~/components/atoms/Global/MdmLoader.vue');
};

export default {
  name: 'MdmInfiniteScroll',
  components: {
    MdmLoader: MdmLoader
  },
  props: {
    total: {
      type: Number,
      default: 3
    },
    from: {
      type: Number,
      default: 0
    },
    nextPage: {
      type: Number,
      default: 1
    },
    previousPage: {
      type: Number,
      default: 1
    },
    size: {
      type: Number,
      default: 40
    },
    progressMsg: {
      type: String,
      default: ''
    },
    buttonMsg: {
      type: String,
      required: true
    },
    loading: {
      type: Boolean,
      required: true
    },
    bottom: {
      type: Boolean,
      default: false
    },
    // I added this props so we can use this component with events
    // @on-previous-page
    // @on-next-page
    useEvents: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    tracking: function tracking() {
      return {
        data: {
          event_category: window.tc_vars.env_template === 'listproduct_keyword' ? 'Search Page' : 'Categorie',
          event_action: 'Clic_plus de produits',
          event_label: "".concat(window.tc_vars.page_cat1, "_").concat(window.tc_vars.page_cat3)
        }
      };
    },
    hasMoreItems: function hasMoreItems() {
      return this.total - this.from > 0;
    },
    percent: function percent() {
      var percent = this.from < this.total ? Math.floor(this.from / this.total * 100) : 100;
      return {
        height: '5px',
        width: "".concat(percent, "%"),
        background: '#c4a181'
      };
    }
  },
  methods: _objectSpread(_objectSpread({}, mapMutations({
    setPreviousPage: 'pageActions/SET_PREVIOUS_PAGE',
    setNextPage: 'pageActions/SET_NEXT_PAGE'
  })), {}, {
    previous: function previous() {
      if (this.useEvents) {
        this.$emit('on-previous-page', this.previousPage);
      } else {
        this.setPreviousPage(this.previousPage - 1);
        updatePageNumber(this.previousPage - 1);
      }
    },
    next: function next() {
      if (this.useEvents) {
        this.$emit('on-next-page', this.nextPage);
      } else {
        this.setNextPage(this.nextPage + 1);
        updatePageNumber(this.nextPage + 1);
      }
    }
  })
};